import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';

var appearanceClassName = {
    red: "tw-bg-red-500",
    blue: "tw-bg-blue-600",
    green: "tw-bg-green-500",
    lightBlue: "tw-bg-blue-200 dark:tw-bg-blue-700 dark:tw-text-blue-200"
};
var sizes = {
    xs: "tw-text-xs",
    sm: "tw-text-sm",
    md: "tw-text-base",
    lg: "tw-text-lg"
};
var Badge = function (_a) {
    var children = _a.children, overrideAppearance = _a.overrideAppearance, appearance = _a.appearance, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, _b = _a.shape, shape = _b === void 0 ? "square" : _b, _c = _a.size, size = _c === void 0 ? "sm" : _c, _d = _a.as, Component = _d === void 0 ? "div" : _d, _e = _a.textColor, textColor = _e === void 0 ? "light" : _e;
    var className = classNames("tw-font-lato tw-inline-block tw-border-none tw-m-0", textColor == "dark" ? "" : "tw-text-dark-bg", sizes[size], shape == "square" && "tw-py-1 tw-px-2 tw-rounded", shape == "circle" &&
        (size == "xs"
            ? "tw-py-[1px] tw-px-1.5 tw-rounded-full"
            : size == "sm"
                ? "tw-py-0.5 tw-px-2 tw-rounded-full"
                : size == "md"
                    ? "tw-py-[3px] tw-px-2.5 tw-rounded-full"
                    : "tw-py-1 tw-px-3 tw-rounded-full"), overrideAppearance ||
        (appearanceClassName[appearance] && appearanceClassName[appearance]));
    var datatestid = dataTestId ||
        "badge-".concat(typeof children === "string" && testIdGen(children));
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": datatestid, className: className }, children));
};

export { Badge };
//# sourceMappingURL=Badge.esm.js.map
